var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "#0191FD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08388 0.75C9.08388 0.335786 8.74809 0 8.33388 0C7.91966 0 7.58388 0.335786 7.58388 0.75V1.15027H4.41688V0.75C4.41688 0.335786 4.0811 0 3.66688 0C3.25267 0 2.91688 0.335786 2.91688 0.75V1.15027H1.91675C0.868314 1.15027 0 1.99092 0 3.05044V5.35083V11.1017C0 12.1612 0.868314 13.0018 1.91675 13.0018H10.084C11.1325 13.0018 12.0008 12.1612 12.0008 11.1017V5.35083V3.05044C12.0008 1.99092 11.1325 1.15027 10.084 1.15027H9.08388V0.75ZM10.5008 4.60083V3.05044C10.5008 2.83951 10.3243 2.65027 10.084 2.65027H9.08388V3.05035C9.08388 3.46456 8.74809 3.80035 8.33388 3.80035C7.91966 3.80035 7.58388 3.46456 7.58388 3.05035V2.65027H4.41688V3.05035C4.41688 3.46456 4.0811 3.80035 3.66688 3.80035C3.25267 3.80035 2.91688 3.46456 2.91688 3.05035V2.65027H1.91675C1.67643 2.65027 1.5 2.83951 1.5 3.05044V4.60083H10.5008ZM1.5 6.10083H10.5008V11.1017C10.5008 11.3126 10.3243 11.5018 10.084 11.5018H1.91675C1.67643 11.5018 1.5 11.3126 1.5 11.1017V6.10083Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLight);
export default __webpack_public_path__ + "static/media/calendar-light.c5bda1e4ef0ccf173cd5781be0910360.svg";
export { ForwardRef as ReactComponent };